import { Injectable } from '@angular/core';
import { CrudService } from '@context/frontend/api-client';
import { Content } from '@context/shared/types/common';

/**
 * Read-only content service for the external viewer.
 *
 * It extends {@link CrudService} against the organization `content` collection so
 * the external pages get the same fetch/pagination plumbing the portal uses (via
 * {@link CrudService.fetch}), but it intentionally omits the portal's authoring
 * helpers (create/move/share/path generation). The external viewer only ever
 * lists and reads content, so nothing beyond the inherited read operations is
 * exposed here.
 *
 * The external app never sets the `ORGANIZATION_ID` context, so callers must scope
 * fetches by passing `organizationId` on the pagination object (resolved from the
 * share link). `CrudService.getCollection` falls back to that value.
 */
@Injectable({ providedIn: 'root' })
export class ExternalContentService extends CrudService<Content> {
	static readonly CollectionId = 'content';

	constructor() {
		super(ExternalContentService.CollectionId);
	}
}
